import { AnimatedSprite } from "pixi.js/lib";
import { scanidle } from "../spritesheets/scanidle";
import { scangrind } from "../spritesheets/scangrind";
import { Character, Coordinate } from "../pixiApplication";
import { loadSound, playSound } from "../audio";
import { scanding } from "../spritesheets/scanding";

let count = 0;

export class Scanner implements Character {
  catch: () => void;
  release: (position: Coordinate) => void;
  position: Coordinate;

  sprite: AnimatedSprite;
  idleSprite: AnimatedSprite;
  grindSprite: AnimatedSprite;
  dingSprite: AnimatedSprite;

  id: string;
  mode: "idle" | "grind" | "ding" = "idle";

  constructor(position: Coordinate) {
    this.position = position;
  }

  async initSprites() {
    this.idleSprite = await scanidle();
    this.idleSprite.play();
    this.idleSprite.animationSpeed = 0.1;
    this.idleSprite.anchor = { x: 1 / 6, y: 1 / 4 };

    this.grindSprite = await scangrind();
    this.grindSprite.anchor = { x: 1 / 6, y: 1 / 4 };
    this.grindSprite.animationSpeed = 0.2;

    this.dingSprite = await scanding();
    this.dingSprite.anchor = { x: 1 / 6, y: 1 / 4 };
    this.dingSprite.animationSpeed = 0.2;
    this.dingSprite.loop = false;

    this.sprite = this.idleSprite;

    this.id = `scanner-${count++}`;
  }

  tick() {
    switch (this.mode) {
      case "grind":
        if (this.sprite.uid === this.idleSprite.uid) {
          const grindSound = loadSound("grind");
          grindSound.volume = 0.25;
          playSound(grindSound, "GAME");

          this.sprite = this.grindSprite;
          this.sprite.play();
          setTimeout(() => {
            this.mode = "ding";
          }, 2000);
        }
        break;
      case "ding":
        this.dingSprite.onComplete = () => {
          this.mode = "idle";
        };
        this.dingSprite.onFrameChange = (n) => console.log(n);
        this.sprite = this.dingSprite;
        this.sprite.gotoAndPlay(0);
        break;
      case "idle":
        this.sprite = this.idleSprite;
        break;
    }
  }
}
